###
# Модель цены блюда для конкретного ресторана
###
App.RestaurantPrice = DS.Model.extend
  price         : DS.attr 'number'
  is_hidden     : DS.attr 'boolean'
  options       : DS.attr 'mixed'

  # Внешние связи
  dish          : DS.belongsTo 'dish',       async: true
  draft_dish    : DS.belongsTo 'draft_dish', async: true
  restaurant    : DS.belongsTo 'restaurant', async: true


  # Костыльный метод, чтобы было удобно редактировать ресторанную базовую цену схемы модификаторов
  # вместе с ценой блюда для ресторана
  modifierSchemePrice: (->
    obj = @get('draft_dish.modifier_scheme.restaurant_prices').filter((pr) =>
      pr.get('restaurant.id') == @get('restaurant.id')
    )[0]

    if Ember.isEmpty(obj)
      obj = @store.createRecord 'modifier_scheme_restaurant_price',
        restaurant: @get('restaurant'),
        modifier_scheme: @get('draft_dish.modifier_scheme')

    obj
  ).property('restaurant')

  nullify_price: (->
    if @get('price') == ''
      Em.run.later =>
        @set('price',null) if @get('price') == ''
      , 1000
  ).observes('price')

  priceIsSet: (->
    @get('price') != null || @get('is_hidden')
  ).property('price', 'is_hidden')
